import {call, put} from "redux-saga/effects";
import {api} from "../../api/api";
import {authActions} from "../auth.slice";
import {disableGoogleAutoSelect} from "../googleSignIn";

export function* signOutSaga() {
    try {
        yield call(api.logout);
    } finally {
        disableGoogleAutoSelect();
        yield put(authActions.clearSession());
    }
}
